import $ from '@get-bridge/learn-legacy-shared/dist/utils/jquery';
import { cookieStorage } from '@get-bridge/learn-legacy-packages.bridge-storage';
import { isPlatformActive, getCsrfToken, CSRF_HEADER_NAME } from '@get-bridge/tapestry-sdk';

function addCSRFHeaderToAPIRequests() {
  const isExternalUrl = url => {
    return url[0] !== "/" && url.indexOf(window.location.host) === -1;
  };

  $.ajaxPrefilter((options) => {
    if (!isExternalUrl(options.url)) {
      const csrfHeader = isPlatformActive() ? CSRF_HEADER_NAME : 'X-CSRF-Token';
      const csrfToken = isPlatformActive() ? getCsrfToken() : cookieStorage.getItem('_csrf_token');

      if (csrfToken && options.type.toUpperCase() !== "GET") {
        options.headers = Object.assign({}, options.headers, {
          [csrfHeader]: csrfToken
        });
      }
    }
  });
}

export default {
  addCSRFHeaderToAPIRequests
};



// WEBPACK FOOTER //
// ./jsapp/config/initializers/AjaxExtensions.js